<template>
  <div>
    <v-app-bar
      class="main--text"
      color="primary"
      dark
      fixed
      app
      >
      <v-toolbar-title
        class="title--text"
        style="cursor:pointer"
        @click="$router.push({path: '/'})">Prosense</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        depressed
        @click="$router.push({path: '/teacher/top'})">
        先生の方はこちら
      </v-btn>
      <v-btn
        color="white"
        outlined
        @click="$router.push({name: 'parentSignup'})"
      >
        ユーザ登録画面へ
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
export default {
}
</script>
